exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Theme Colors */\n.connection-read-only-checkbox-container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.connection-read-only-checkbox-container .connection-read-only-checkbox {\n  margin: 0;\n}\n.connection-read-only-checkbox-container .connection-read-only-checkbox .ant-checkbox + span {\n  color: #9ba0aa;\n  font-size: 11px;\n  line-height: 100%;\n  margin-bottom: 5px;\n  user-select: none;\n}\n.connection-read-only-checkbox-container .warning-icon {\n  color: #ff4d4f;\n  font-size: 14px;\n}\n", ""]);

// exports
